import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.bind";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import ControlledTabs from './controlled-tabs';
/**
 * A tabbed uncontrolled implementation for multiple views.
 */

var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);
    _this.state = {
      activeTabIndex: props.initialActiveTabIndex
    };
    _this.onActiveTabChange = _this.onActiveTabChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tabs, [{
    key: "onActiveTabChange",
    value: function onActiveTabChange(activeTabIndex) {
      if (this.state.activeTabIndex !== activeTabIndex) {
        this.setState({
          activeTabIndex: activeTabIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var activeTabIndex = this.state.activeTabIndex;
      return /*#__PURE__*/React.createElement(ControlledTabs, _extends({
        onActiveTabChange: this.onActiveTabChange,
        activeTabIndex: activeTabIndex
      }, this.props));
    }
  }]);

  return Tabs;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


Tabs.displayName = 'Tabs';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types'); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  Tabs.propTypes = {
    /** The individual tabs to generate - should be <Tab> components */
    children: PropTypes.node,

    /** Class name(s) to apply to the component */
    className: PropTypes.string,

    /** Flag to disable tracking that is mainly for use when you don't want the component
        to cause any side effects (Storybook, NDS Style Guide, testing, etc). Should not
        be set in a practical use case. */
    disableTracking: PropTypes.bool,

    /** This id will be used for tracking purposes as the `sectionCategory` */
    id: PropTypes.string,

    /** The index of the active tab on render. Defaults to 0. */
    initialActiveTabIndex: PropTypes.number,

    /** If true, the tab content will remember its state when switching tabs.
     Defaults to true */
    rememberState: PropTypes.bool,

    /* Optional if you want to skip the margin-bottom between the tab and content, defaulted to true */
    hasMarginBetweenTabsAndContent: PropTypes.bool
  };
} // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


Tabs.defaultProps = {
  className: null,
  children: null,
  disableTracking: false,
  id: '',
  initialActiveTabIndex: 0,
  rememberState: true,
  hasMarginBetweenTabsAndContent: true
};
export default Tabs;